/** 昵称的纯函数。和后端 `account/profile.py` 的规则对齐。 */

/** 和后端 NICK_MAX 一致 */
export const NICK_MAX = 24;

/**
 * 昵称长度，**按码点数** —— 和后端 Python 的 `len()` 一样。
 * `.length` 数的是 UTF-16 单元：一个 emoji 算 2，计数器会比后端多报，
 * 玩家看着 23/24 提交却被说"太长"。
 */
export function nickLength(s: string): number {
  return Array.from(s.trim()).length;
}
